//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'GravesCAS',
  components: {},
  data () {
    return {
      form: {
        retrobulbar: '0',
        eyemove: '0',
        eyered: '0',
        eyeblood: '0',
        chemosis: '0',
        caruncular: '0',
        eyechemosis: '0',
        eyeover2: '0',
        eyedown5: '0',
        snellen: '0'
      },
      hasScore: false,
      disabled: false
    }
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.retrobulbar + form.eyemove + form.eyered + form.eyeblood + form.chemosis + form.caruncular + form.eyechemosis + form.eyeover2 + form.eyedown5 + form.snellen
      self.hasScore = true
      if (result < 3) {
        self.descTxt = '死亡率低（＜2%）'
      } else if (result > 2) {
        self.descTxt = '死亡率高（＞15%）'
      }
      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/GravesCAS.vue